const UserRole = [
  'MEMBER',
  'ADMIN',
  'MODERATOR',
  'CONFIGURATOR',
  'SUPER_ADMIN',
];

export const UserRoleName = {
  MEMBER: 'Member',
  ADMIN: 'ADMIN',
  MODERATOR: 'ADMIN',
  CONFIGURATOR: 'CONFIGURATOR',
  SUPER_ADMIN: 'ADMIN',
};

const checkPrivilege = (userPriv, allowed) =>
  allowed.indexOf(`${userPriv}`) >= 0;

export const isAllowedToDelete = (userPriv) =>
  checkPrivilege(userPriv, ['1', '2', '4']);
export const isAllowedToMultiDelete = (userPriv) =>
  checkPrivilege(userPriv, ['1', '2', '4']);
export const isAllowedToSuspend = (userPriv) =>
  checkPrivilege(userPriv, ['1', '2', '4']);
export const isAllowedToBlockIp = (userPriv) => checkPrivilege(userPriv, ['4']);
export const isAllowedToManageTop = (userPriv) =>
  checkPrivilege(userPriv, ['1', '4']);

export const getUserRole = (userPriv) => {
  if (!checkPrivilege(userPriv, ['1', '2', '4'])) {
    return '';
  }
  const role = UserRole[userPriv];
  return UserRoleName[role];
};

export default UserRole;
